import { User } from "./user.model";

export class CustomerVenueNoteItem {
	pk: string; //LOG_venueKey
	sk: string; //logCreateDateTime.unix_comment_commentCreateDateTime.unix
	authorUserKey: string;
	created: string;
	body: string;
	notifications: string[];
	attachmentKey: string[];
	deleted: boolean;

	authorUser: User;

	public constructor(init?: Partial<CustomerVenueNoteItem>) {
		Object.assign(this, init);
	}
}
